import { BehaviorSubject, Subject } from 'rxjs';
import { Component, OnDestroy, OnInit, ViewChild  } from '@angular/core';
import { InvitationsService } from 'app/services';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { Invitation } from 'app/models';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-invites',
  templateUrl: './invites.component.html',
  styleUrls: ['./invites.component.scss'],
})
export class InvitesComponent implements OnInit, OnDestroy {
  displayedColumns = [
    'email',
    'dateInvited',
    'companyName'
  ];
  message = 'Users_not_found';
  title = '';
  error: string;
  noRecordFound: boolean;
  queryString: string;
  loading: boolean;
  invites = [];
  private searchValSubject = new BehaviorSubject<string>(null);
  searchVal$ = this.searchValSubject.asObservable();
  currentPageInvites: Invitation[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  invitesDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<Invitation>(true, []);
  searching: true

  constructor(
    public _invitesService: InvitationsService,
    private _router: Router,
    private _translateService: TranslateService
  ) {}
  private onDestroy$ = new Subject<void>();

  ngOnInit() {
    this.getHeader(false);

    this.searchVal$
      .pipe(takeUntil(this.onDestroy$), debounceTime(250))
      .subscribe((res) => {
        if (res !== '' && res != null) {
          this.getHeader(true);
          this.loading = true;
          const encodedSearch = encodeURIComponent(this.queryString);
          this._invitesService.getRecentInvitations(encodedSearch);
        }
      });

    this._invitesService.recentInvitations$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((invites) => {
        this.loading = false;
        this.invites = invites;
        this.invitesDataSource.data = this.invites;
        this.invitesDataSource.paginator = this.paginator;
        this.invitesDataSource
            .connect()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((invitesList) => {
              this.currentPageInvites = invitesList;
            });
      });

    this.loading = true;
    this._invitesService.getRecentInvitations();
  }

  getHeader(isSearch: boolean) {
    let key = 'Recent_Invitations';
    if (isSearch) {
      key = 'Search_Results';
    }
    this._translateService
      .get(key)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.title = value;
      });
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    this.error = '';
    if (this.queryString == null || this.queryString === '') {
      this._invitesService.getRecentInvitations();
      this.getHeader(false);
    } else if (this.queryString.length >= Number(environment.minimumSearchLength)) {
      this.searchValSubject.next(search);
    }
  }

  public handleNavigate(row) {
    this._router.navigate([
      '/company',
      row.companyId.toLowerCase(),
    ]);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
